export const chunkArray = <T>(arr: T[], size: number): T[][] => {
	const slices = Math.ceil(arr.length / size);
	return [...Array(slices)].map((_, index) => arr.slice(size * index, size + size * index));
};